<template>
  <div class="container">
    <transition-group name="slide-fade" mode="out-in">
      <Questions v-if="view" key="Questions" @change="changeView" />
      <Question-content v-else key="QuestionContent" @change="changeView" />
    </transition-group>
  </div>
</template>

<script>
import Questions from '@/components/personalCenter/myQuestion/questions.vue'
import QuestionContent from '@/components/personalCenter/myQuestion/questionContent.vue'
export default {
  name: 'my-question',
  components: { Questions, QuestionContent },
  props: [],
  data() {
    return {
      view: true,
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    changeView(val) {
      this.view = val
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #edf2f6;
}
</style>